import { aboutPoints } from "@/mocks/home";

export default function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs md:text-sm">
              <i className="ri-information-line" />
              关于本站
            </span>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              一个专心做地址导航的页面
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              本站只做一件事：在 91免费 官网地址发生变动后，把可用的入口地址集中同步到这里。我们不做内容聚合、不做论坛，也不提供任何需要注册的功能，目的就是让你在地址失效时能快速、清楚地找到下一步该打开哪里。
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {aboutPoints.map((point) => (
                <div key={point.id} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                    <i className={`${point.icon} text-xl`} />
                  </span>
                  <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">{point.title}</h3>
                  <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{point.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-4 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <h3 className="font-heading font-bold text-base text-foreground-950">更新说明与免责声明</h3>
              <ul className="mt-3 flex flex-col gap-2 text-sm text-foreground-700 leading-relaxed">
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-primary-600 mt-0.5 shrink-0" />
                  本页会按每日多次的频率同步可用线路，并在每张地址卡片上标注同步时间，请以更新时间最近的入口为准。
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-primary-600 mt-0.5 shrink-0" />
                  页面中的地址为演示用的示例格式，仅用于说明导航方式，不构成对任何具体域名或服务的承诺。
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-primary-600 mt-0.5 shrink-0" />
                  本页不收集、不索取任何账号、密码或个人信息，也不会要求你进行注册或登录。
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}